export const FETCH_BRAILLE_SHEETS = 'FETCH_BRAILLE_SHEETS';
export const CREATE_BRAILLE_SHEET = 'CREATE_BRAIILE_SHEET';
export const DELETE_BRAILLE_SHEET = 'DELETE_BRAIILE_SHEET';
export const UPDATE_BRAILLE_SHEET = 'UPDATE_BRAIILE_SHEET';
export const FETCH_QUESTIONS = 'FETCH_QUESTIONS';
export const FETCH_STAFF_BRAILLE_SHEEETS = 'FETCH_STAFF_BRAILLE_SHEEETS';
export const CREATE_STAFF_BRAILLE_SHEET = 'CREATE_STAFF_BRAILLE_SHEET';
export const DELETE_STAFF_BRAILLE_SHEET = 'DELETE_STAFF_BRAILLE_SHEET';
export const FETCH_MY_BRAILLE_SHEETS = 'FETCH_MY_BRAILLE_SHEETS';
export const CREATE_MY_BRAILLE_SHEET = 'CREATE_MY_BRAILLE_SHEET';